export const filterWomensFootball = <T>(items: T[]): T[] => {
  const href = window.location.href;
  const isDev = href.includes("dev-machinefootball-app.azurewebsites.net") || href.includes("localhost") || href.includes("127.0.0.1");
  const isProd = href.includes("machinefootball-app.azurewebsites.net") && !href.includes("dev-machinefootball-app") && !href.includes("qa-machinefootball-app") && !href.includes("stag-machinefootball-app");

  const checkIsWomens = (item: any): boolean => {
    if (item.isWomens === true || item.isWomens === 'true') return true;
    if (item.team && (item.team.isWomens === true || item.team.isWomens === 'true')) return true;
    return false;
  };

  if (isProd) {
    return items.filter(item => !checkIsWomens(item));
  }
  if (isDev) {
    return items.filter(item => checkIsWomens(item));
  }
  return items;
};
